<template>
    <div>
        <div class="switcher"
             :class="{ 'switcher--on': turn, 'switcher--off': !turn}"
             @click="clickHandler">
            <div class="switcher__bar">
                <div class="switcher__circle"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'switcher',
    props: {
        turn: {
            type: Boolean,
            default: false,
        },
        tag: {
            type: String,
            required: true,
        },
    },
    methods: {
        clickHandler() {
            console.log(`${this.tag} - ${this.turn}`)
            this.$store.dispatch('turnTag', this.tag)
        }
    }
}
</script>

<style lang="scss" scoped>
.switcher {
    $root: &;
    
    cursor: pointer;

    &__bar {
        height: 1.2rem;
        width: 2.6rem;
        display: flex;
        align-items: center;
        position: relative;
        border-radius: 20px;
        #{$root}--off & {
            background: #c1c1c1;
        }
        #{$root}--on & {
            background: #4f9e49;
        }
    }
    
    &__circle {
        $size: 1.8rem;
        height: $size;
        width: $size;
        border-radius: 50%;
        position: absolute;
        box-shadow: 0px 1px 1px 0px #000;
        #{$root}--off & {
            left: -2px;
            background: #e1e1e1;
        }
        #{$root}--on & {
            right: -2px;
            background: #30D126;
        }
    }
}
</style>
